export const socialLinks = [
  {
    platform: 'X',
    handle: '@TNTTerritory',
    href: 'https://x.com/TNTTerritory',
    icon: 'ri-twitter-x-line',
  },
  {
    platform: 'LinkedIn',
    handle: 'Top Notch Technologies',
    href: 'https://www.linkedin.com/company/topnotch-technologies',
    icon: 'ri-linkedin-line',
  },
  {
    platform: 'Instagram',
    handle: '@topnotchterritory',
    href: 'https://www.instagram.com/topnotchterritory',
    icon: 'ri-instagram-line',
  },
  {
    platform: 'Facebook',
    handle: 'Top Notch Territory',
    href: 'https://www.facebook.com/TopNotchTerritory/',
    icon: 'ri-facebook-line',
  },
];